export function dateSetterFormatter(dateValue: any) {
  const month = (dateValue.getMonth() + 1).toString().padStart(2, '0');
  const day = dateValue.getDate().toString().padStart(2, '0');
  const year = dateValue.getFullYear().toString();

  const formattedDate = `${month}-${day}-${year}`;
  return formattedDate;
}
